<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <sequential-entrance from-top>
      <v-row>
        <v-col>
          <base-material-card
            color="primary"
            icon="mdi-bank-transfer-out"
            inline
            title="Payments for Group"
          >
            <v-col cols="12">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              />
            </v-col>
            <v-spacer />
            <v-data-table
              :headers="headers"
              :items="groupforuser"
              :search="search"
              sort-by="calories"
              class="elevation-1"
            >
              <template v-slot:[`item.wallet`]="{ item }">
                <v-btn
                  small
                  fab
                  class="mr-2"
                  color="purple"
                  @click="request_check_transfer(item)"
                >
                  <v-icon dark>
                    mdi-qrcode
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.postdeposits`]="{ item }">
                <v-btn
                  small
                  fab
                  class="mr-2"
                  color="orange"
                  @click="request_check_transfer(item)"
                >
                  <v-icon dark>
                    mdi-checkbook
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.postshipments`]="{ item }">
                <v-btn
                  small
                  fab
                  class="mr-2"
                  color="blue"
                  @click="request_ach_transfer(item)"
                >
                  <v-icon dark>
                    mdi-transfer-right
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.tracking`]="{ item }">
                <v-btn
                  small
                  fab
                  class="mr-2"
                  color="green"
                  @click="request_payment_history(item)"
                >
                  <v-icon dark>
                    mdi-clock
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <v-btn
                  color="primary"
                  @click="initialize"
                >
                  Reset
                </v-btn>
              </template>
            </v-data-table>
          </base-material-card>

          <div class="py-3" />
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'Wallets',

    data () {
      return {
        bal: '',
        search: '',
        valid: true,
        headers: [
          { text: 'Group', value: 'name', sortable: true },
          { text: 'Digital Wallet', value: 'wallet', align: 'center', sortable: false },
          { text: 'Send Check', value: 'postdeposits', align: 'center', sortable: false },
          { text: 'ACH', value: 'postshipments', align: 'center', sortable: false },
          { text: 'History', value: 'tracking', align: 'center', sortable: false },
        ],
        items: [],
        error: '',
        dialog: false,
        icons: true,
        centered: true,
        newtab: null,
        activeBtn: 1,
        grow: true,
        tab: null,

        tabs: 0,
      }
    },
    timers: {
      log: { time: 300000, autostart: true, repeat: true }
    },
    computed: {
      currentsafes () {
        this.$log.debug('SAFES ARE ', this.$store.getters.safesstatus)
        return this.$store.getters.safesstatus
      },
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      },
      groupforuser () {
        let groups = []
        if (this.$store.getters.user.status === 'admin') {
          return this.$store.getters.usergroups
        }
        this.$store.getters.usergroups.forEach(entry => {
          if (entry.name === this.$store.getters.user.group) {
            groups.push(entry)
          }
        })
        return groups
      }
    },
    created () {
      // this.$store.dispatch('resetsafetransactions')
      // this.items = this.$store.getters.safesstatus
    },
    methods: {
      log () {
        // this.$store.dispatch('loadsafes')
      },
      format_time (ts) {
        this.$log.debug('TS ', ts)
        return moment(ts).format('MMMM Do, h:mm:ss')
      },
      request_check_transfer (machine) {
        console.log(machine)
        this.$router.push({ path: '/PaymentsCheck/' + machine.name })
      },
      request_ach_transfer (machine) {
        console.log(machine)

        this.$router.push({ path: '/PaymentsAch/' + machine.name })
      },
      request_payment_history (machine) {
        console.log(machine)

        this.$router.push({ path: '/PaymentsHistory/' + machine.name })
      },
      request_mailbox_deposit (machine) {
        this.$log.debug('REQUEST POST CALLED ', machine)
        this.$log.debug(machine)
        // :to="'/alerts/' + item.id"
        this.$log.debug('ID passed ', machine.id)
        // this.$store.dispatch("loadAlerts", machine.id)
        this.$log.debug('machine id passed ', machine.safeid)
        this.$router.push({ path: '/Depositpost/' + machine.safeid })
      },
      request_mailbox_shipments (machine) {
        this.$log.debug('REQUEST SHIPMENTS CALLED ', machine)
        this.$log.debug(machine)
        // :to="'/alerts/' + item.id"
        this.$log.debug('ID passed ', machine.id)
        // this.$store.dispatch("loadAlerts", machine.id)
        this.$router.push({ path: '/Depositshipments/' + machine.safeid })
      },
      request_mailbox_tracking (machine) {
        this.$log.debug('REQUEST SHIPMENTS CALLED ', machine)
        this.$log.debug(machine)
        // :to="'/alerts/' + item.id"
        this.$log.debug('ID passed ', machine.id)
        // this.$store.dispatch("loadAlerts", machine.id)
        this.$router.push({ path: '/DepositTracking/' + machine.safeid })
      },
      request_labels (machine) {
        this.$log.debug('REQUEST LABELS CALLED ', machine)
        this.$log.debug(machine)
        // :to="'/alerts/' + item.id"
        this.$log.debug('ID passed ', machine.id)
        // this.$store.dispatch("loadAlerts", machine.id)
        this.$router.push({ path: '/Depositlabels/' + machine.safeid })
      },
      request_transactions (machineid) {
        this.$log.debug('machine id passed ', machineid)
      },
      reset () {
        this.wallet = ''
        this.dialog = false
      },
      onDecode (result) {
        // strip out crypto:address
        this.wallet.address = result
      },
      logErrors (promise) {
        promise.catch(console.error)
      },
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
